// extracted by mini-css-extract-plugin
export default {"container":"Upload_container__Wdx92","input":"Upload_input__138k+","customFileInput":"Upload_customFileInput__Mc-7y","icon":"Upload_icon__p5Ki2"};